import React from 'react';
import { useProCalculator } from '../hooks/useProCalculator';
import ProCalculatorFooter from './ProCalculatorFooter';
import SectionHelp from './SectionHelp';
import ToggleSwitch from './ToggleSwitch';
import '../styles/SetsSection.css';

const SetsSection = () => {
  const {
    useSets,
    setUseSets,
    setRows,
    updateSetRow,
    addSetRow,
    removeSetRow,
    cookieRows,
    isMobile,
    goToNextSection,
    activeSection,
    loadedPlanName
  } = useProCalculator();

  return (
    <div className="sets-section">
      {/* Header with title and plan name */}
      <div className="section-header">
        <h2 className="section-title">Cookie Sets</h2>
        {loadedPlanName && <span className="loaded-plan-name">Plan: {loadedPlanName}</span>}
      </div>

      {/* Help text container */}
      <div className="section-help-container">
        <SectionHelp sectionId="sets" isMobile={isMobile} />
      </div>
      
      <div className="sets-toggle-container">
        <label className="sets-toggle-label"> 
          Use Cookie Sets
        </label>
        <ToggleSwitch
          isOn={useSets}
          onToggle={setUseSets}
        />
      </div>
      
      {useSets && (
        <div className="sets-table">
          <div className="sets-table-header">
            <div className="set-name-header">Set Name</div>
            <div className="cookie-name-header">Cookie</div>
            <div className="count-header">Count</div>
            <div className="actions-header">Actions</div>
          </div>
          
          {setRows.map(row => (
            <div key={row.id} className="set-row">
              <div className="set-name-field">
                <input
                  type="text"
                  value={row.setName}
                  onChange={(e) => updateSetRow(row.id, 'setName', e.target.value)}
                  className="set-name-input"
                />
              </div>
              
              <div className="cookie-name-field">
                <select
                  value={row.cookieId}
                  onChange={(e) => updateSetRow(row.id, 'cookieId', e.target.value)}
                  className="cookie-name-select"
                >
                  <option value="">Select a cookie</option>
                  {cookieRows
                    .filter(cookieRow => cookieRow.cookieName !== 'Cookie Name')
                    .map(cookieRow => (
                      <option key={cookieRow.id} value={cookieRow.cookieId}>
                        {cookieRow.cookieName}
                      </option>
                    ))
                  }
                </select>
              </div>
              
              <div className="count-field">
                <input
                  type="number"
                  min="1"
                  max="99"
                  value={row.count}
                  onChange={(e) => {
                    const value = Math.min(99, Math.max(1, parseInt(e.target.value) || 1));
                    updateSetRow(row.id, 'count', value);
                  }}
                  className="count-input"
                />
              </div>
              
              <div className="actions-field">
                <button 
                  onClick={() => removeSetRow(row.id)} 
                  className="btn-delete" 
                  title="Remove Row"
                >
                  <span className="minus-icon">-</span>
                </button>
                <button 
                  onClick={() => addSetRow(row.setName)} 
                  className="btn-create" 
                  title="Add Row"
                >
                  <span className="plus-icon">+</span>
                </button>
              </div>
            </div>
          ))}
          
          {setRows.length === 0 && (
            <div className="set-row">
              <div className="set-name-field">
                <input
                  type="text"
                  defaultValue="Set 1"
                  onChange={(e) => updateSetRow(1, 'setName', e.target.value)}
                  className="set-name-input"
                />
              </div>
              
              <div className="cookie-name-field">
                <select
                  defaultValue=""
                  onChange={(e) => updateSetRow(1, 'cookieId', e.target.value)}
                  className="cookie-name-select"
                >
                  <option value="">Select a cookie</option>
                  {cookieRows
                    .filter(cookieRow => cookieRow.cookieName !== 'Cookie Name')
                    .map(cookieRow => (
                      <option key={cookieRow.id} value={cookieRow.cookieId}>
                        {cookieRow.cookieName}
                      </option>
                    ))
                  }
                </select>
              </div>
              
              <div className="count-field">
                <input
                  type="number"
                  min="1"
                  max="99"
                  defaultValue="1"
                  onChange={(e) => {
                    const value = Math.min(99, Math.max(1, parseInt(e.target.value) || 1));
                    updateSetRow(1, 'count', value);
                  }}
                  className="count-input"
                />
              </div>
              
              <div className="actions-field">
                <button 
                  onClick={() => addSetRow('Set 1')} 
                  className="btn-create" 
                  title="Add Row"
                >
                  <span className="plus-icon">+</span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      
      {/* Footer with Save/Save As/Clear and Next buttons */}
      {activeSection !== 'all' && (
        <ProCalculatorFooter
          onNext={() => goToNextSection('sets')}
          nextLabel="Next: Size & Shape"
        />
      )}
    </div>
  );
};

export default SetsSection;
